import { FaDownload, FaEllipsisH, FaFilter, FaSignOutAlt, FaStore, FaUpload, FaUser } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './BonComptoireList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaEdit, FaFilePdf, FaPlus, FaSearch, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';

import { formatPrice, formatSigned } from '../../helpers/utility';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { CBL_PAGE, PAY_PAGE, POS_PAGE, RETOUR_PAGE } from '../../routes/routeConstants';
import { productActions } from '../../sagas/productSlice';
import { authActions } from '../../sagas/authSlice';
import POSHeader from './POSHeader';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { buildEscPosReceipt } from '../../helpers/printUtility';
const BonComptoireList = () => {
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.deliveryNotes);
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedBonLivraison, setSelectedBonLivraison] = useState(null);
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const clients = useSelector(state => state.clients.clients);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed
    const { businessName, email, address, telephone, fullName } = useSelector(state => state.auth);
    const [activeTab, setActiveTab] = useState("VENTES");
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const [pdfModal, setPdfModal] = useState(false);
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });
    const [selectedClient, setSelectedClient] = useState(null);

    const searchInputRef = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(productActions.findAllUnites());
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.listComptoire(payload));
    }, [filters]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };

    const handleLogout = () => {
        Swal.fire({
            title: t('auth.logoutConfirmTitle'),
            text: t('auth.logoutConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(authActions.logout());
                Swal.fire({
                    icon: 'success',
                    title: t('auth.logoutSuccess'),
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    navigate('/login');
                });
            }
        });
    };


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel'
            ];
            if (!allowedTypes.includes(file.type)) {
                Swal.fire({
                    icon: 'error',
                    title: t('product.invalidFileType'),
                    text: t('product.excelOnly'),
                });
                return;
            }

            try {
                const formData = new FormData();
                formData.append('file', file);

                let payload = {
                    formData: formData,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: t('delivery.uploadSuccess'),
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#198754'
                        });
                        refrechBLs();
                    },
                }
                dispatch(deliveryActions.uploadBLs(payload));

            } catch (error) {
                console.error('Error parsing Excel:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur!',
                    text: "Erreur lors de l'importation des produits",
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
            } finally {
                // Reset file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const refrechBLs = () => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.listComptoire(payload));
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];

    const handleGeneratePdf = async (receiptData, format = "THERMAL") => {
        if (format === 'A5') {
            generateA5PDF(receiptData)
        } else {
            const isAndroid = /Android/i.test(navigator.userAgent);
            console.log(isAndroid)
            if (isAndroid) {
                printEscPosReceipt({
                    businessName,
                    address,
                    telephone,
                    receiptData,
                })
            } else {
                try {
                    const doc = new jsPDF({
                        orientation: 'portrait',
                        unit: 'mm',
                        format: [80, 300],
                    });
                    doc.internal.scaleFactor = 1;

                    const pageWidth = 80;
                    const margin = 4;
                    let y = 6;

                    /* ================= HEADER ================= */
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(14);
                    const companyTitle = businessName || 'MATJARPOS';
                    const titleLines = doc.splitTextToSize(
                        companyTitle,
                        pageWidth - margin * 2
                    );

                    // Dessin centré ligne par ligne
                    titleLines.forEach((line, index) => {
                        doc.text(line, pageWidth / 2, y + index * 5, { align: 'center' });
                    });

                    // Ajuster Y dynamiquement selon le nombre de lignes
                    y += titleLines.length * 5;

                    doc.setFontSize(9);
                    doc.setFont('helvetica', 'normal');
                    if (address) {
                        const lines = doc.splitTextToSize(address, pageWidth - margin * 2);
                        lines.forEach((l, i) =>
                            doc.text(l, pageWidth / 2, y + i * 3, { align: 'center' })
                        );
                        y += lines.length * 3;
                    }
                    if (telephone) {
                        doc.text(telephone, pageWidth / 2, y + 3, { align: 'center' });
                        y += 6;
                    }

                    doc.line(margin, y, pageWidth - margin, y);
                    y += 5;

                    /* ================= INFO ================= */
                    doc.setFontSize(9);
                    doc.setFont('helvetica', 'bold');
                    doc.text('REÇU DE VENTE', pageWidth / 2, y, { align: 'center' });
                    y += 5;

                    doc.setFontSize(9);
                    doc.setFont('helvetica', 'normal');
                    doc.text(`N° : ${receiptData?.numero || '-'}`, margin, y);
                    doc.text(
                        `Date : ${receiptData?.createdAt || '-'}`,
                        pageWidth - margin,
                        y,
                        { align: 'right' }
                    );
                    y += 4;
                    doc.text(`Vendeur: ${receiptData?.createdBy || '---'}`, margin, y);
                    y += 4;
                    doc.text(`Client : ${receiptData?.clientNom || 'Passager'}`, margin, y);
                    y += 4;
                    doc.line(margin, y, pageWidth - margin, y);
                    y += 3;

                    /* ================= ARTICLES HEADER ================= */
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(9);

                    doc.text('Article', margin, y);
                    doc.text('Qté', pageWidth - 42, y, { align: 'center' });
                    doc.text('PU', pageWidth - 26, y, { align: 'right' });
                    doc.text('Total', pageWidth - margin, y, { align: 'right' });

                    y += 3;
                    doc.line(margin, y, pageWidth - margin, y);
                    y += 3;

                    /* ================= ARTICLES LINES ================= */
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(9);

                    receiptData?.lignes?.forEach(item => {
                        const name =
                            item.articleNom.length > 18
                                ? item.articleNom.slice(0, 18) + '…'
                                : item.articleNom;

                        const qte = Number(item.quantiteLivree || 0);
                        const pu = Number(item.prixUnitaireTTC || 0);
                        const total = Number(item.montantTTC || qte * pu);

                        // Article
                        doc.text(name, margin, y);

                        // Quantité
                        doc.text(String(qte), pageWidth - 42, y, { align: 'center' });

                        // Prix unitaire
                        doc.text(formatPrice(pu, false), pageWidth - 26, y, {
                            align: 'right',
                        });

                        // Total
                        doc.text(formatPrice(total, false), pageWidth - margin, y, {
                            align: 'right',
                        });

                        y += 6;
                    });

                    doc.line(margin, y, pageWidth - margin, y);
                    y += 4;

                    /* ================= TOTAL ================= */
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(10);
                    doc.text('TOTAL TTC', margin, y);
                    doc.text(
                        formatPrice(receiptData?.montantTotalTTC, false),
                        pageWidth - margin,
                        y,
                        { align: 'right' }
                    );
                    y += 6;

                    doc.line(margin, y, pageWidth - margin, y);
                    y += 4;

                    /* ================= PAIEMENT ================= */
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(9);

                    const modeLabel = getModeReglementLabel(receiptData?.modeReglement);
                    doc.text(`Mode paiement : ${modeLabel}`, margin, y);
                    y += 4;

                    doc.text('Montant payé :', margin, y);
                    doc.text(
                        formatPrice(receiptData?.montantPaye, false),
                        pageWidth - margin,
                        y,
                        { align: 'right' }
                    );
                    y += 4;

                    if (
                        receiptData?.modeReglement === 'ESPECES' &&
                        receiptData?.montantPaye > receiptData?.montantTotalTTC
                    ) {
                        doc.text('Monnaie :', margin, y);
                        doc.text(
                            formatPrice(
                                receiptData.montantPaye - receiptData.montantTotalTTC,
                                false
                            ),
                            pageWidth - margin,
                            y,
                            { align: 'right' }
                        );
                        y += 4;
                    }

                    doc.line(margin, y, pageWidth - margin, y);
                    y += 6;

                    /* ================= SOLDE CLIENT ================= */
                    if (
                        !receiptData?.isComptoir &&
                        receiptData?.clientTotalDebit &&
                        receiptData?.clientTotalCredit
                    ) {
                        doc.setFont('helvetica', 'bold');
                        doc.setFontSize(9);
                        doc.text('SOLDE CLIENT', margin, y);

                        doc.setFont('helvetica', 'normal');
                        doc.text(
                            formatClientSolde(
                                receiptData.clientTotalDebit,
                                receiptData.clientTotalCredit
                            ),
                            pageWidth - margin,
                            y,
                            { align: 'right' }
                        );
                        y += 6;
                    }

                    /* ================= FOOTER ================= */
                    doc.setFontSize(9);
                    doc.text('Merci de votre confiance', pageWidth / 2, y, {
                        align: 'center',
                    });
                    y += 4;
                    doc.text('Powered by MatjarPOS', pageWidth / 2, y, {
                        align: 'center',
                    });

                    if (isAndroid) {
                        // ✅ ANDROID / POS TABLET
                        doc.autoPrint({ variant: 'non-conform' });

                        const blob = doc.output('blob');
                        const url = URL.createObjectURL(blob);

                        const iframe = document.createElement('iframe');
                        iframe.style.display = 'none';
                        iframe.src = url;

                        document.body.appendChild(iframe);

                        iframe.onload = () => {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                        };
                    } else {
                        // ✅ DESKTOP WEB
                        const blobUrl = doc.output('bloburl');
                        window.open(blobUrl, '_blank');
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        }

    };

    const printEscPosReceipt = data => {
        const escpos = buildEscPosReceipt(data);
        const encoded = encodeURIComponent(escpos);

        window.location.href = `rawbt://print?text=${encoded}`;
    };

    const getModeReglementLabel = (mode) => {
        switch (mode) {
            case 'ESPECES': return 'Espèces';
            case 'CARTE_BANCAIRE': return 'Carte bancaire';
            case 'CHEQUE': return 'Chèque';
            case 'VIREMENT': return 'Virement';
            case 'TRAITE': return 'Traite';
            default: return mode || '-';
        }
    };

    const formatClientSolde = (totalDebit, totalCredit) => {
        const debit = Number(totalDebit || 0);
        const credit = Number(totalCredit || 0);

        // RÈGLE MÉTIER : crédit - débit
        const solde = credit - debit;

        const sign = solde > 0 ? '+' : solde < 0 ? '-' : '';
        return `${sign}${formatPrice(Math.abs(solde), false)}`;
    };

    const generateA5PDF = async (receiptData) => {
        try {
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a5',
            });

            const pageWidth = 148;
            const margin = 10;
            let y = 15;

            // ===== HEADER =====
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(16);
            doc.text(businessName || 'MATJARPOS', pageWidth / 2, y, { align: 'center' });
            y += 8;

            doc.setFontSize(9);
            doc.setFont('helvetica', 'normal');
            if (address) {
                doc.text(address, pageWidth / 2, y, { align: 'center' });
                y += 5;
            }
            if (telephone) {
                doc.text(telephone, pageWidth / 2, y, { align: 'center' });
                y += 6;
            }

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            // ===== INFO =====
            doc.setFontSize(10);
            doc.setFont('helvetica', 'bold');
            doc.text('REÇU DE VENTE', pageWidth / 2, y, { align: 'center' });
            y += 6;

            doc.setFont('helvetica', 'normal');
            doc.text(`N° : ${receiptData?.numero}`, margin, y);
            doc.text(`Date : ${receiptData?.dateOperation}`, pageWidth - margin, y, { align: 'right' });
            y += 6;

            doc.text(`Client : ${receiptData?.clientNom || 'Passager'}`, margin, y);
            y += 6;

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            // ===== ARTICLES =====
            doc.setFont('helvetica', 'bold');
            doc.text('Article', margin, y);
            doc.text('Qté', pageWidth - 60, y);
            doc.text('Total', pageWidth - margin, y, { align: 'right' });
            y += 4;

            doc.line(margin, y, pageWidth - margin, y);
            y += 4;

            doc.setFont('helvetica', 'normal');
            receiptData?.lignes?.forEach(item => {
                const article = doc.splitTextToSize(item.articleNom, 70);
                doc.text(article, margin, y);
                doc.text(String(item.quantiteLivree), pageWidth - 60, y);
                doc.text(formatPrice(item.montantTTC, false), pageWidth - margin, y, { align: 'right' });
                y += article.length * 4 + 2;
            });

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            // ===== TOTAL =====
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.text('TOTAL TTC', margin, y);
            doc.text(formatPrice(receiptData?.montantTotalTTC, false), pageWidth - margin, y, { align: 'right' });
            y += 8;

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            // ===== PAIEMENT =====
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);

            const modeLabel = getModeReglementLabel(receiptData?.modeReglement);
            doc.text(`Mode de paiement : ${modeLabel}`, margin, y);
            y += 6;

            doc.text('Montant payé :', margin, y);
            doc.text(formatPrice(receiptData?.montantPaye, false), pageWidth - margin, y, { align: 'right' });
            y += 6;

            if (
                receiptData?.modeReglement === 'ESPECES' &&
                receiptData?.montantPaye > receiptData?.montantTotalTTC
            ) {
                doc.text('Monnaie :', margin, y);
                doc.text(
                    formatPrice(receiptData.montantPaye - receiptData.montantTotalTTC, false),
                    pageWidth - margin,
                    y,
                    { align: 'right' }
                );
                y += 6;
            }

            doc.line(margin, y, pageWidth - margin, y);
            y += 8;

            // ===== SOLDE CLIENT =====
            if (!receiptData?.isComptoir && receiptData?.clientTotalDebit && receiptData?.clientTotalCredit) {
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(10);
                doc.text('SOLDE CLIENT', margin, y);

                doc.setFont('helvetica', 'normal');
                doc.text(
                    formatClientSolde(
                        receiptData.clientTotalDebit,
                        receiptData.clientTotalCredit
                    ),
                    pageWidth - margin,
                    y,
                    { align: 'right' }
                );

                y += 8;
            }

            // ===== FOOTER =====
            doc.setFontSize(9);
            doc.text('Merci de votre confiance', pageWidth / 2, y, { align: 'center' });
            y += 4;
            doc.text('Powered by MatjarPOS', pageWidth / 2, y, { align: 'center' });

            window.open(URL.createObjectURL(doc.output('blob')));
        } catch (e) {
            console.error(e);
        }
    };


    const handleEdit = (bl) => {
        setSelectedBonLivraison(bl);
        setShowModal(true);
    }


    const debouncedSearch = useCallback(
        debounce((query) => {
            dispatch(deliveryActions.listComptoire({
                ...filters,
                query: query
            }));
        }, 1500), // Wait 1.5 seconds after user stops typing
        [filters.query]
    );


    return (
        <Container fluid>
            <POSHeader
                businessName={businessName || "MATJARPOS"}
                fullName={fullName}
                activeTab={activeTab}
                onChangeTab={(tab) => {
                    setActiveTab(tab);

                    if (tab === "VENTES") navigate(CBL_PAGE);
                    if (tab === "AVANCE") navigate(PAY_PAGE);
                    if (tab === "RETOURS") navigate(RETOUR_PAGE);
                }}
            />

            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0 fw-bold text-primary">
                                    {t('delivery.list')}
                                </h5>

                                <Button
                                    color="primary"
                                    className="d-flex align-items-center"
                                    onClick={() => navigate(POS_PAGE)}
                                >
                                    <FaPlus className="me-2" />
                                    {t('delivery.new')}
                                </Button>
                            </div>
                            <div className="filter-container mb-4">
                                <Row className="mb-3 g-2 align-items-end">
                                    <Col lg={3} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md={3}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>

                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>                            {/* Summary Statistics Box */}


                            <table className="table table-hover table-striped table-bordered" >
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center">{t('delivery.numero')}</th>
                                        <th className="align-middle text-center">{t('commande.client')}</th>
                                        <th className="align-middle text-center">{t('commande.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('delivery.commercial')}</th>
                                        <th className="align-middle text-center">{t('devis.montantTTC')}</th>
                                        <th className="align-middle text-center">{t('reglement.montantPaye')}</th>
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((bl) => (
                                        <tr key={bl.id}>
                                            <td className="align-middle text-center">{bl.numero}</td>
                                            <td className="align-middle text-center">
                                                {bl.clientNom || 'N/A'}
                                            </td>
                                            <td className="align-middle text-center">{bl.createdAt}</td>
                                            <td className="align-middle text-center">{bl.commercialNom || 'LOCAL'}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(bl.montantPaye, false)}</td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-success">{t('delivery.livre')}</span>
                                                )}
                                                {bl.status === 'RETOUR' && (
                                                    <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                                )}
                                            </td>
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={bl.estRegle}
                                                    readOnly
                                                />
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            setSelectedReceipt(bl);
                                                            setPdfModal(true);
                                                        }}
                                                    >
                                                        <FaFilePdf />
                                                    </Button>
                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleEdit(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaEdit />
                                                    </Button>


                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {list.length === 0 && (
                                        <tr>
                                            <td colSpan="9" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="4" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(list.reduce((sum, bl) => sum + (bl.montantPaye || 0), 0), false)}</td>
                                        <td colSpan="3"></td>
                                    </tr>
                                </tfoot>

                            </table>
                        </>)}
                </CardBody>
            </Card>

            <Modal isOpen={pdfModal} toggle={() => setPdfModal(false)} centered>
                <ModalHeader toggle={() => setPdfModal(false)}>
                    Choisir le format du reçu
                </ModalHeader>
                <ModalBody className="d-flex justify-content-center gap-3">
                    <Button
                        color="primary"
                        onClick={() => {
                            handleGeneratePdf(selectedReceipt, "THERMAL");
                            setPdfModal(false);
                        }}
                    >
                        🧾 Thermique (80mm)
                    </Button>

                    <Button
                        color="secondary"
                        onClick={() => {
                            handleGeneratePdf(selectedReceipt, "A5");
                            setPdfModal(false);
                        }}
                    >
                        📄 A5
                    </Button>
                </ModalBody>
            </Modal>

        </Container>
    );
};

export default BonComptoireList;



